import "../../utils/detail.css";
import { ArrowDownOutlined, ArrowUpOutlined, CloseOutlined, CopyOutlined, FilePdfOutlined, FilePdfTwoTone } from "@ant-design/icons";
import { Avatar, Tooltip, Switch, Tag } from "antd";
import { useState } from "react";
import { Button, Col, Row, Modal } from "reactstrap";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";

import CardImageItem from "../../../../common/image/cardImage";
import defaultLogo from "../../../../assets/images/noImage.avif";
import { countryInfo } from "../PaymentMethodSelector";
import { updateEnvironment } from "../../services/developerApi";
import UploadDocument from "../uploadDoc";
import { uploadFilesBusinessById } from "../../../media/services/mediaApi";
import DocumentCard from "./DocumentCard";
import { maskKey } from "../../../../common/format/maskedData";

const DetailBusiness = ({ modal, setModal, toggle, selectedDeveloper, onUpdateDeveloper, currentuser }) => {

  const [showAll, setShowAll] = useState(false);
  const [error, setError] = useState(null);

  const [documents, setDocuments] = useState({
    businessRegistryFileName: null,
    ninea: null,
    statut: null,
  });

  const [isUploadingDocs, setIsUploadingDocs] = useState(false);
  const updateEnvironmentMutation = useMutation(updateEnvironment);
  
  const queryClient = useQueryClient();

  const {
    id,
    businessName,
    type,
    description,
    logo,
    businessRegistryFileName,
    nineaFileName,
    statutFileName,
    apiKey,
    apiToken,
    environmentMod
  } = selectedDeveloper || {};
  
  const [environment, setEnvironment] = useState(environmentMod || "SANDBOX");

  const countryPaymentMethods = Array.isArray(selectedDeveloper?.countryPaymentMethods)
    ? selectedDeveloper.countryPaymentMethods
    : [];

  const allMethods = countryPaymentMethods.flatMap((block) =>
    (block.paymentMethods || []).map((method) => ({
      ...method,
      country: block.country,
    }))
  );

  const displayedMethods = showAll ? allMethods : allMethods.slice(0, 3);

  const handleCopy = (key, name) => {
    if (!key) {
      toast.info("Désolé pas de clé à copier");
    } else {
      navigator.clipboard.writeText(key);
      toast.success(`Clé ${name || ""} copiée avec succès`);
    }
  };

  const switchEnvironment = (checked) => {
    const request = {
      businessId: id,
      mode: checked ? "LIVE" : "SANDBOX",
    };

    updateEnvironmentMutation.mutate(request, {
      onSuccess: () => {
        queryClient.invalidateQueries(["developers"]);
        setEnvironment(checked ? "LIVE" : "SANDBOX");
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message || "Erreur");
      },
    });
  };

  const handleDocChange = (name, file) => {
    setDocuments((prev) => ({
      ...prev,
      [name]: file,
    }));
  };

  const handleUploadDocuments = async () => {
    const payload = {};
    if (documents?.businessRegistryFileName) payload.businessRegistryFileName = documents?.businessRegistryFileName;
    if (documents?.nineaFileName) payload.nineaFileName = documents?.nineaFileName;
    if (documents?.statutFileName) payload.statutFileName = documents?.statutFileName;

    if (Object.keys(payload).length === 0) {
      return toast.error("Ajoutez au moins un document");
    }

    setIsUploadingDocs(true);

    try {
      const response = await uploadFilesBusinessById(id, payload);

      if(response){
        onUpdateDeveloper({
          ...selectedDeveloper,
          businessRegistryFileName:response?.businessRegistryFileName || selectedDeveloper?.businessRegistryFileName,
          nineaFileName:response?.nineaFileName || selectedDeveloper?.nineaFileName,
          statutFileName:response?.statutFileName || selectedDeveloper?.statutFileName,
        });
      }

      toast.success("Documents uploadés avec succès 🎉");

      queryClient.invalidateQueries(["developers"]);

      setDocuments({
        businessRegistryFileName: null,
        nineaFileName: null,
        statutFileName: null,
      });

    } catch (err) {
      setError(err || err?.message || "Une erreur est survenue.");
      toast.error("Erreur upload documents");
    } finally {
      setIsUploadingDocs(false);
    }
  };

  const hasDocs = documents.businessRegistryFileName || documents.nineaFileName || documents.statutFileName;


  return (
    <Modal
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop="static"
      style={{ maxWidth: "900px" }}
    >
      <div className="modal-content-custom">
        <div className="modal-header-custom">
          <h1 className="title-detail-modal">
            Détail de mon business {businessName} du {selectedDeveloper?.country || "-"}
          </h1>
          <CloseOutlined className="close-btn" onClick={() => setModal(false)} />
        </div>

        <Row>

          <div className="detail-div">
            <Row className="align-items-start mb-4">
              <Col lg={2} className="logo-container">
                <Avatar size={80}>
                  <CardImageItem fileName={logo} token={currentuser?.token} />
                </Avatar>
              </Col>
              <Col lg={10}  className="env-switch-container">
                <Tag color={environment === "SANDBOX" ? "orange" : "green"}>
                  {environment === "SANDBOX" ? "Mode test" : "Mode Prod"}
                </Tag>
                <Switch
                  title="Cliquer pour Changer les modes"
                  checked={environment === "LIVE"}
                  onChange={switchEnvironment}
                  checkedChildren="LIVE"
                  unCheckedChildren="SANDBOX"
                  style={{
                    backgroundColor: environment === "LIVE" ? "#52c41a" : "#faad14",
                  }}
                />
              </Col>

              <Col lg={12} className="mt-3">
                <h5 className="title">Description</h5>
                <p className="business-description">
                  {description || "Pas de description disponible"}
                </p>
              </Col>
            </Row>

            {/* <div>
              <h5 className="title">Informations du business</h5>
              <table className="recap-table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Type</th>
                    <th>Pays</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{businessName || "-"}</td>
                    <td>{type || "-"}</td>
                    <td>{selectedDeveloper?.country || "-"}</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
          </div>

          <hr className="hr-detail-business" />
          <div className="detail-div">
            <h5 className="title">Clés API</h5>
            <Row>
              <Col lg={6} className="mb-2">
                <label className="title">API Key</label>
                <div className="api-key-container">
                  <input className="title api-key-input" value={maskKey(apiKey) || "-"} readOnly />
                  <Tooltip title="Copier le apiKey">
                    <Button className="copy-btn" onClick={() => handleCopy(apiKey, "apiKey")} >
                      Copier
                    </Button>
                  </Tooltip>
                </div>
              </Col>

              <Col lg={6} className="mb-4">
                <label className="title">API Token</label>
                <div className="api-key-container">
                  <input className="title api-key-input" value={maskKey(apiToken) || "-"} readOnly />
                  <Tooltip title="Copier le apiToken">
                    <Button className="copy-btn" onClick={() => handleCopy(apiToken, "apiToken")}>
                      Copier
                    </Button>
                  </Tooltip>
                </div>
              </Col>
            </Row>
          </div>
          
          <hr className="hr-detail-business" />

          <div className="detail-div">
            <h5 className="title">Documents requis </h5>
            {!hasDocs && (!businessRegistryFileName || !nineaFileName || !statutFileName) && (
              <p className="title text-center mt-2">
                Ajoutez au moins un document pour soumettre
              </p>
            )}

            <Row className="mb-4">
              <Col lg={4}>
                {businessRegistryFileName ? (
                  <DocumentCard
                    title="Registre du commerce"
                    file={businessRegistryFileName}
                    token={currentuser?.token}
                  />
                ) : (
                  <UploadDocument
                    label="Registre du commerce"
                    value={documents.businessRegistryFileName}
                    onChange={(file) =>
                      handleDocChange("businessRegistryFileName", file)
                    }
                    colSize={12}
                  />
                )}
              </Col>

              <Col lg={4}>
                {nineaFileName ? (
                  <DocumentCard
                    title="Ninéa"
                    file={nineaFileName}
                    token={currentuser?.token}
                  />
                ) : (
                  <UploadDocument
                    label="Ninea"
                    value={documents.nineaFileName}
                    onChange={(file) => handleDocChange("nineaFileName", file)}
                    colSize={12}
                  />
                )}
              </Col>

              <Col lg={4}>
                {statutFileName ? (
                  <DocumentCard
                    title="Statut"
                    file={statutFileName}
                    token={currentuser?.token}
                  />
                ) : (
                  <UploadDocument
                    label="Statut"
                    value={documents.statutFileName}
                    onChange={(file) => handleDocChange("statutFileName", file)}
                    colSize={12}
                  />
                )}
              </Col>

              {error && (
                <div className="alert alert-danger">
                  {error?.message || error?.toString()}
                </div>
              )}

              {(!businessRegistryFileName || !nineaFileName || !statutFileName) && hasDocs && (
                <Col lg={12} className="text-center mt-3">
                  <Button
                    color="primary"
                    onClick={handleUploadDocuments}
                    disabled={isUploadingDocs}
                  >
                    {isUploadingDocs ? "Enregistrement en cours..." : "Soumettre document"}
                  </Button>
                </Col>
              )}

            </Row>
          </div>

          <hr className="hr-detail-business" />
          
          <div className="detail-div mb-4">
            <h5 className="title">Méthodes de paiement</h5>

            {allMethods.length > 0 ? (
              <>
                <table className="recap-table">
                  <thead>
                    <tr>
                      <th>Pays</th>
                      <th>Méthode</th>
                      <th>Devise</th>
                      <th>Préfixe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedMethods.map((method, i) => (
                      <tr key={i}>
                        <td>
                          {countryInfo[method.country]?.name || method.country}
                        </td>
                        <td>
                          {method.urlLogo && (
                            <img
                              src={method.urlLogo || defaultLogo}
                              style={{ width: 20, marginRight: 6, display: "inline-block", verticalAlign: "middle" }}
                              alt=""
                            />
                          )}
                          {method.name}
                        </td>
                        <td>{method.currency}</td>
                        <td>{method.prefixCode}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                {allMethods.length > 5 && (
                  <div style={{ marginTop: "1rem", textAlign: "center" }}>
                    <button
                      className="transfer-toggle-btn"
                      onClick={() => setShowAll(!showAll)}
                    >
                      {showAll ? (
                        <>
                          <ArrowUpOutlined /> Voir moins
                        </>
                      ) : (
                        <>
                          <ArrowDownOutlined /> Voir plus
                        </>
                      )}
                    </button>
                  </div>
                )}
              </>
            ) : (
              <p>Aucune méthode de paiement renseignée</p>
            )}
          </div>

        </Row>
      </div>
    </Modal>
  );
};

export default DetailBusiness;